import { ToastrService } from 'ngx-toastr';
import { StagesTimeControlDataService } from './shared/stages-time-control.data.service';
import { Component, Input, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { AuthenticationService, Logger } from '@app/core';
import {
  BaseControl,
  ConfirmComponent,
  Rol,
  Const,
  EtapaBase
} from '@app/shared';
import { LocalDataSource } from 'ng2-smart-table';
import { StagestimecontrolFormService } from './shared/stages-time-control.form.service';
import { StagesTimeControlConfigService } from './shared/stages-time-control.config.service';
import { TimeContolDataService } from '../shared/time-contol.data.service';
import { Static } from '@app/shared';

const log = new Logger('StagestimecontrolComponent');

@Component({
  selector: 'iw-stages-timecontrol',
  templateUrl: './stages-time-control.component.html',
  styleUrls: ['./stages-time-control.component.scss'],
  providers: [
    StagesTimeControlDataService,
    StagestimecontrolFormService,
    TimeContolDataService
  ]
})
export class StagesTimeControlComponent implements OnInit {
  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Define si el rol en accion es para editar o agregar
  rolEdit = true;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    update: false,
    delete: false,
  };
  // Configuracion de la tabla
  settings = {};
  // contiene las etapas
  source: LocalDataSource;
  // Datos para llenar la tabla
  _stages: EtapaBase[];
  @Input() set stages(s: EtapaBase[]) {
    this._stages = s;
    this.loadingStages();
  }
  get stages(): EtapaBase[] {
    return this._stages;
  }

  // Contiene el rol seleccionado
  stageSelect: Rol;
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Evento de salida que notifica ala padre para actualizar las etapas
  @Output() refreshStages: EventEmitter<boolean> = new EventEmitter();
  constructor(
    private stcds: StagesTimeControlDataService,
    private toastr: ToastrService,
    private stcfs: StagestimecontrolFormService,
    private tcds: TimeContolDataService,
    private as: AuthenticationService
  ) { }

  ngOnInit() {
    // determina los permisos del usuario en sesions
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.created,
    );
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.review,
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.update,
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.delete,
    );

    log.debug(this.activateAction);
    const configTable = new StagesTimeControlConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      log.debug(res.action, res.data);
      this.defineActionCondictions(res.action, res.data);
    });
    this.loadingStages();
  }

  /**
   * Controla las diferentes acciones de agregar, modificar o eliminar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof StagestimecontrolComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        if (this.activateAction.created) {
          this.formOpen = true;
          this.rolEdit = false;
          this.actionForm = 'Agregar';
          this.controls = this.stcfs.getFormStage();
        } else {
          this.toastr.error('Usted no posee permisos para agregar etapas en el sistema', 'Permiso denegado');
        }
        break;
      case 'update':
        if (this.activateAction.update) {
          this.formOpen = true;
          this.rolEdit = true;
          this.actionForm = 'Modificar';
          this.stageSelect = data;
          this.controls = this.stcfs.getFormStage(this.stageSelect);
        } else {
          this.toastr.error('Usted no posee permisos para modificar etapas en el sistema', 'Permiso denegado');
        }
        break;
      case 'delete':
        if (this.activateAction.delete) {
          this.stageSelect = data;
          this.question = '¿Realmente desea eliminar la etapa?';
          this.confirm.open();
        } else {
          this.toastr.error('Usted no posee permisos para eliminar etapas en el sistema', 'Permiso denegado');
        }
        break;
    }
  }

  loadingStages() {
    const st: EtapaBase[] = [];
    this.stages.forEach(stage => {
      const stg = Static.copyObjet(stage);
      stg['delete'] = this.activateAction.delete;
      stg['update'] = this.activateAction.update;
      st.push(stg);
    });
    this.source = new LocalDataSource(st);
    this.source.refresh();
  }


  /**
   * Guarda o edita un rol(grupo) en el sistema
   *
   * @param {*} data
   * @memberof ManagementGroupsComponent
   */
  sended(data: any) {
    if (data) {
      let stage: EtapaBase;
      stage = {
        nombre: data.txtNombre
      };
      if (this.rolEdit) {
        this.stcds.updateStage(this.stageSelect.id, stage).then(() => {
          this.closeFormStages();
          this.refreshStages.emit();
        }).catch(() => {
          this.closeFormStages();
        });
      } else {
        this.stcds.addStage(stage).then(() => {
          this.closeFormStages();
          this.refreshStages.emit();
        }).catch(() => {
          this.closeFormStages();
        });
      }
    }
  }

  /**
   * Controla la accion de confimacion del modal
   *
   * @param {boolean} res
   * @memberof StagestimecontrolComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteStage();
    }
    this.question = '';
  }


  /**
   * Elimina una etapa del sistema
   *
   * @private
   * @memberof StagestimecontrolComponent
   */
  private deleteStage() {
    this.stcds.deleteStage(this.stageSelect.id).then(() => {
      this.closeFormStages();
      this.refreshStages.emit();
    }).catch(() => {
      this.closeFormStages();
    });
  }

  /**
   * Cierra la vista del formulario de creacion o edicion de una etapa
   *
   * @memberof StagestimecontrolComponent
   */
  closeFormStages() {
    this.actionForm = '';
    this.question = '';
    this.formOpen = false;
    this.rolEdit = false;
    this.stageSelect = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/time-control/stages-time-control/stages-time-control.component.ts